import {useState, useEffect, useRef} from "react";
import { Chart as ChartJS, ArcElement, Legend, Tooltip, Title, Filler } from "chart.js";
import { Doughnut } from "react-chartjs-2";
import { getgraphicsprinc, getparamsgraphics } from "../../../services/graphics";
import CardService from "./cardservice";
import { ErrorContext } from "../../../utils/context/error";
import AreaModal from "./areamodal";
import Card from "../../card";
import CardInfo from "./cardinfo";
import Icon from "../../../Icons/general/Icon";


function GraphicPrincView() {
   const [AreaFId, setAreaFId] = useState(0);
   const [CantTurnos, setCantTurnos] = useState(0);
   const [Turnos, setTurnos] = useState([]);
   const [servicio, setServicio] = useState([]);
   const [datos, setDatos] = useState([]);
   const [isOpen, setisOpen]= useState(false);

   const { setShowToast, setOpciones } = ErrorContext();
   
   let TotalTurnos = useRef(0);
   let NombreArea = useRef("");
   let NombreEstado = useRef([]);
   let Color = useRef([]);
   let FillColor = useRef([]);
   let Procesos = useRef(0);
   ChartJS.register(ArcElement, Tooltip, Legend, Title, Filler);
 /***
 * 
 */
  useEffect(() => {
    fillInicioGrafica();
  },[]);

  //----
  const realizarConsulta =(AreaId) =>
  {
   if (AreaId ===0)
    fillInicioGrafica()
  else  
    fillGrafica(AreaId);

  }
 //-----
  const fillInicioGrafica = async() => 
    {
      const response = await getparamsgraphics();
      if (response) 
        {
          if (response.status === 200) 
            {
              setAreaFId(response.data.area[0].AreaId);
              realizarConsulta(response.data.area[0].AreaId);
            }
          else
          {
           const Mensaje = response.message;
           const opc = { type: "Danger", message: Mensaje, active: true };
           setOpciones(opc);
           setShowToast(true);
          }
        }
    }
  /**
  * 
  */
  const fillGrafica = async (AreaId) => {
    if (AreaId >0)
    {
       const response = await getgraphicsprinc(AreaId);
       if (response) 
        {
           if (response.status === 200) 
            {
               CargarDatos(response.data.data[0]);
               setDatos(response.data.data[0]);
               NombreArea.current = response.data.area[0].NombreArea; 
               setAreaFId(response.data.area[0].AreaId);
               setServicio(response.data.servicio);
            }
           else
           {
               const Mensaje = response.message;
               const opc = { type: "Danger", message: Mensaje, active: true };
               setOpciones(opc);
               setShowToast(true);
           }
        }
        else
           {
               const Mensaje = response.message;
               const opc = { type: "Danger", message: Mensaje, active: true };
               setOpciones(opc);
               setShowToast(true);
           }
    }       
  };
  /**
   * 
   */
  const CargarDatos = (resultados) => {
    let  Turno=[];
    NombreEstado.current=[];
    FillColor.current=[];
    Color.current=[];
    if (resultados)
    {
      const { Consecutivo, Atendido, PorAtender, Pendientes } = resultados;
      TotalTurnos.current = Consecutivo;
      let Proceso = Consecutivo - Atendido - PorAtender - Pendientes;
      Procesos.current = Proceso;
      
      if (PorAtender >0)
      {
       Turno.push({Estado:'PorAtender', Cantidad:PorAtender});
       NombreEstado.current.push('Por Atender | '+PorAtender);
       Color.current.push('rgba(255, 152, 36, 0.5)');
       FillColor.current.push('rgba(255, 152, 36)');
      }
  
      if (Atendido >0)
      {
        Turno.push({Estado:'Atendidos', Cantidad:Atendido});
        NombreEstado.current.push('Atendidos | '+Atendido);
        Color.current.push('rgba(22, 189, 202, 0.5)');
        FillColor.current.push('rgba(22, 189, 202, 73)');
      }

      if (Pendientes >0)
      {
        Turno.push({Estado:'Pendientes', Cantidad:Pendientes});
        NombreEstado.current.push('Pendientes | '+Pendientes);
        Color.current.push('rgba(203, 67, 53, 0.5)');
        FillColor.current.push('rgba(203, 67, 53)');
      }  

      if (Proceso >0)
      {
         Turno.push({Estado:'Proceso', Cantidad:Proceso});
         NombreEstado.current.push('En Proceso | '+Proceso);
         Color.current.push('rgba(231, 70, 148, 0.5)');
         FillColor.current.push('rgba(231, 70, 148, 73)');
      }
    }
    setTurnos(Turno);
    setCantTurnos(TotalTurnos.current);
  }
/**
 * 
 */  
  const data = {
    labels: NombreEstado.current,
    datasets: [
      {
        backgroundColor: Color.current,
        borderColor: FillColor.current,
        borderWidth: 1,
        cutout:'75%',
        offset:5,
        label:'Turnos:', 
        data:Turnos,
      },
    ],
  };
   
  const options ={
    responsive: true,
    maintainAspectRatio: false,
    UpdateMode:'normal',
    parsing: {
       key: 'Cantidad'
    },
    layout:{
      padding: {
        top: 2,
        bottom: 2,
    }
    },
    plugins: {
      tooltip: false,
      legend: {
        display: false,
        position: 'right',
        align:'center',
        labels: {
          color: '#000000',
          usePointStyle: true,
          pointStyle:'circle',
          boxWidth:10
        }
      },
    }
  };
  const emptyDoughnut = {
       id: 'emptyDoughnut',
       afterDraw(chart) {
        const {datasets} = chart.data;
        const {chartArea: {left, top, right, bottom}, ctx} = chart;
          if (datasets[0].data.length ===0)
          {
            const centerX = (left + right) / 2;
            const centerY = (top + bottom) / 2;
            const r = Math.min(right - left, bottom - top) / 2;
                
            ctx.beginPath();
            ctx.lineWidth = 16;
            ctx.strokeStyle = '#D8D8D7';
            ctx.arc(centerX, centerY, (r - 18 || 0), 0, 2 * Math.PI);
            ctx.stroke();
             
            /*ctx.font = 'bold 17px Roboto';
            ctx.textBaseline = "middle";
            ctx.textAlign='center';
            ctx.fillStyle = "#212F3D";
            ctx.fillText(`Total Turnos: 0`, centerX,centerY);*/
          }
          else{
            ctx.lineWidth =  2;
          }
      }
  };
  //const plugins= [ CenterTextLine,customDatalabels,  emptyDoughnut ]; //
  const plugins= [emptyDoughnut ];
   /**
    * 
    */   
   return (
        <>
        <div className="w-full min-h-screen bg-white" >
           <div className='grow'>
             <div className="flex flex-row h-8 mb-2">
                <h2 className='flex h-6 text-2xl font-semibold text-gray-500 leading-none'>{NombreArea.current}</h2>
                <div onClick={()=>setisOpen((prev) => !prev)}>
                 <Icon className={`w-4 h-4 text-gray-500 fill-current hover:text-gray-600 focus:ring-4 focus:outline-none  focus:ring-gray-500 cursor-pointer mt-2`}  
                 svg='trespuntos' ></Icon>
                 </div>
             </div>  
             {isOpen && <div id="dropdownDots" className={`z-10 bg-white divide-y divide-gray-100 rounded-lg shadow-md w-44 absolute border border-stone-200 `}>
                  <ul className="py-2 text-sm text-gray-700 dark:text-gray-200" >
                    <li>
                      <a href="#" className="block px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white">Dashboard</a>
                    </li>
                    <li>
                     <a href="#" className="block px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white">Settings</a>
                    </li>
                    <li>
                     <a href="#" className="block px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white">Earnings</a>
                    </li>
                 </ul>
             </div>   }    
             
              <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 xl:grid-cols-4">
                <CardInfo
                  icon={<Icon svg="usercheck" />}
                  title="Atendidos"
                  value={datos?.Atendido ?? 0}
                  color="text-cyan-500"
                  bgColor="bg-cyan-50"
                />

                <CardInfo
                  icon={<Icon svg="userclock" />}
                  title="Por Atender"
                  value={datos?.PorAtender ?? 0}
                  color="text-orange-400"
                  bgColor="bg-orange-50"
                />

                <CardInfo
                  icon={<Icon svg="userslash" />}
                  title="Pendientes"
                  value={datos?.Pendientes ?? 0}
                  color="text-blue-600"
                  bgColor="bg-blue-50"
                />

                <CardInfo
                  icon={<Icon svg="usersline" />}
                  title="En Proceso"
                  value={Procesos.current ?? 0}
                  color="text-pink-500"
                  bgColor="bg-pink-50"
                />
              </div> 
            <div className='grid grid-cols-1  xl:grid-cols-3 gap-6 w-full '>
               <div className='flex flex-row bg-white p-4  border border-stone-200 rounded-lg shadow-md min-h-[4rem] '>
                  <div className="flex flex-1 w-[14rem] h-[14rem] 2xl:w-[20rem] 2xl:h-[20rem]">
                     <Doughnut  data={data} options={options}  plugins={plugins} />
                  </div>
                  <div className="flex flex-2 flex-col justify-center items-center leading-8 2xl:leading-[3rem]">
                     <h1 className="font-semibold text-5xl 2xl:text-6xl  text-default">{CantTurnos}</h1>
                     <p className="text-lg 2xl:text-xl text-gray-500">Total Turno</p>
                 </div>
               </div>
               <div className='bg-white p-4 rounded-lg shadow-md xl:col-span-2 border border-stone-200 flex flex-col items-start gap-4'>
                 <h3 className='text-xs font-light text-gray-500 mb-4'>Servicios en Producción</h3>
                      <div className=''>
                          {servicio.length ===0 && <div className='w-10 h-10 flex items-center text-center justify-center text-gray-400 fill-current'>
                             <Icon svg='information'></Icon>
                          </div>}     
                            {servicio.length >0 ? (<div className="flex flex-wrap gap-4 justify-start  items-start">
                            { servicio.map((item) => 
                            { 
                               return ( 
                                  <CardService key={item.AreaId + item.ServicioId} AreaId={item.AreaId} ServicioId={item.ServicioId}></CardService> 
                               ); 
                            })}
                            </div>)
                           :
                            <h2 className={`text-[0.75rem] text-gray-400 ml-2`}>No hay Servicios en Producción</h2>
                          }  
                       </div> 
                       
               </div>
             </div>
           </div>
            
  </div>     
        
      </>
     );
  }
  export default GraphicPrincView;
  